<template>
  <!-- :active-text-color="variables.menuActiveText" :background-color="variables.menuBg" -->
  <div :class="{'has-logo':showLogo}">
    <!-- <logo v-if="showLogo" :collapse="isCollapse" /> -->
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :text-color="variables.menuText"
        :active-text-color="variables.menuActiveText"
        :unique-opened="true"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item v-for="route in filterRoutes" :key="route.name" :item="route" :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'

export default {
  // components: { SidebarItem, Logo },
  components: { SidebarItem },
  data() {
    return {
      filterRoutes: []
    }
  },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    routes() {
      return this.$router.options.routes
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  watch: {
    routes: {
      handler(val) {
        this.filterRoutes = this.filterMenu(val).filter(item => item.children && item.children.length)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    filterMenu(menuList) {
      return menuList.filter((item) => {
        return !item.hidden && (item.meta === undefined || item.meta.code === undefined ? this.powerReg(1) : this.powerReg(item.meta.code))
      }).map((item) => {
        item = Object.assign({}, item)
        if (item.children && item.children.length > 0) {
          item.children = this.filterMenu(item.children)
        }
        return item
      })
    }
  }
}
</script>
